module.exports = "<button md-icon-button (click)=\"back()\">\n    <md-icon>arrow_back</md-icon>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-back/toolbar-back.component.html
// module id = ../../../../../src/app/toolbar/toolbar-back/toolbar-back.component.html
// module chunks = 4